import { UpsertMasterAdapterSettingsInterface } from '@feature/dashboard/settings/adapter-settings/types/upsert-adapter-settings';
import { REGEX_CONSTANT } from '@sharedModule/constants/pattern-regex.constant';

export const upperCaseToWords = (value?: string | null): string => {
  if (!value) {
    return '';
  }
  return value.replace(REGEX_CONSTANT.upperCamelCase, ' $1').trim();
};

export const toTitleCase = (value = ''): string => {
  const firstLetter = value.at(0);
  if (!firstLetter) {
    return '';
  }
  return firstLetter.toUpperCase().concat(value.substring(1));
};

export const to1stCharLower = (value = ''): string => {
  const firstLetter = value.at(0);
  if (!firstLetter) {
    return '';
  }
  return firstLetter.toLowerCase().concat(value.substring(1));
};

export const isEmpty = (value = ''): boolean => value.length === 0;

export const isEqualIgnoreCase = (
  valueOne: string,
  valueTwo: string
): boolean => valueOne.toLowerCase() === valueTwo.toLowerCase();

export const insertSpaces = (value: string): string => {
  const str = value
    .replace(/(_|-)/g, ' ')
    .trim()
    .replace(/\w\S*/g, function (str: string) {
      return str.charAt(0).toUpperCase() + str.substr(1);
    })
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
  return str;
};

export function convertToAbbreviation(val: number): string {
  // Create a new Intl.NumberFormat object with options
  const formatter = new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumSignificantDigits: 3,
  });

  // Format the number and return the result
  return formatter.format(val);
}

export function formatObjectNames(
  obj: UpsertMasterAdapterSettingsInterface
): UpsertMasterAdapterSettingsInterface {
  if (!obj || !obj.settings || !Array.isArray(obj.settings)) {
    return obj;
  }

  return {
    ...obj, // Spread all existing properties
    settings: obj.settings.map(setting => ({
      ...setting, // Spread all existing setting properties
      name: formatString(setting.name), // Format only the name field
    })),
  };
}

function formatString(str: string): string {
  if (!str) return '';

  return str
    .replace(/\s+/g, '_') // Replace one or more spaces with underscore
    .toLowerCase(); // Convert to lowercase
}
